import Vue from 'vue';
import Router from 'vue-router';
import Home from './pages/Home.vue';
import Login from './pages/Login.vue';
import NotFound from './pages/NotFound.vue';
import store from '@/store';
import { defaultClient } from '@/services/api';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'login',
      path: '/pmp_login',
      component: Login,
    },
    {
      name: 'home',
      path: '/',
      component: Home,
      meta: {
        requireAuth: true,
      },
    },
    {
      name: 'error',
      path: '*',
      component: NotFound,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const acceptedLocales = ['en', 'fr', 'de', 'sv', 'da', 'nl', 'it', 'es'];
  let lang = store.state.partner.lang || 'en';
  if (to.query && to.query.lang && typeof (to.query.lang) === 'string') {
    lang = to.query.lang.toLowerCase();
    if (acceptedLocales.includes(lang)) {
      await store.dispatch('changeLanguage', lang);
    }
  } else {
    await store.dispatch('changeLanguage', lang);
  }

  if (store.state.partner.token) {
    defaultClient.authentications.apiKey.apiKey = `Basic ${store.state.partner.token}`;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to error page.
    if (!store.state.partner.token) {
      next('/error');
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
